/**
 * 火车票查询车次类
 */
export default class Train {
  constructor(train = {}, byTrainDate) {
    Object.assign(this, train)

    // 20180101 -> '2018-01-01'
    this.byTrainDate = byTrainDate
    this.saleDateTime = train.saleDateTime || '预订'

    /**
     * runTime上游返回 '99小时xx' 的时候代表列表停运
     * 但是saleDateTime还是返回 '预订'，这里处理成不可预订
     */
    if (this.runTime && this.runTime.indexOf('99') === 0) {
      this.saleDateTime = '列车暂停发售'
      this.runTime = ''
      this.startTime = '23:59'
      this.arriveTime = ''
      this.arriveDays = '0'
    }

    this.seatList = train.seatList.map(seat => new Seat(seat))
  }

  // 是否可预订
  get canBook () {
    return this.saleDateTime === '预订'
  }

  // 到达时天数是否展示
  get arriveDayShow () {
    return this.arriveDays && this.arriveDays !== '0'
  }

  // 获取座席的最低价格展示出来
  get minPrice () {
    let seat = this.seatList.find((seat) => {
      return seat.seatCount != 0
    })
    return seat ? seat.price : 0
  }

  // 该躺列车 出发站是不是始发站
  get isStartStation () {
    return this.startStationName === this.fromStationName
  }

  // 该躺列车 出发站是不是始发站
  get isEndStation () {
    return this.endStationName === this.toStationName
  }

}

/**
 * 火车票车次座席类
 */
export class Seat {
  constructor (seat = {}) {
    this.price = seat.price // 价格
    this.seatCount = seat.seatCount // 剩余座位数
    this.seatName = seat.seatName // 座位名称
    this.seatType = seat.seatType // 座位类型代码
    this.wb = seat.wb // 是否违背  1 - 只做提醒，选择违背事项 | 2 - 不可预订
    this.checked = false
  }

  // 是否显示违背
  get wbShow () {
    return this.wb == 1 || this.wb == 2
  }

  // 是否可预订
  get canBook () {
    return !(this.seatCount <= 0 || this.wb == 2)
  }

  /**
   * 列表上展示的座席张数
   */
  get seatCountStr () {
    if(isNaN(this.seatCount)) {
      return '99 张'
    }else if (this.seatCount === '21' || this.seatCount === 21){
      return '有票'
    }else {
      return `${this.seatCount} 张`
    }


  }

  /**
   * 车次详情上展示的座席张数，略带描述性
   */
  get seatCountLabel () {
    if (this.seatCount === '0') {
      return '无票'
    } else {
      return `仅 ${this.seatCountStr}`
    }
  }
}
